export class InvalidActivationLinkError extends Error {
  constructor() {
    super(`Invalid activation link.`);
  }
}
